module.exports = __webpack_public_path__ + "img/puesta-en-valor-2.d05514b2.jpg";